module.exports = __webpack_public_path__ + "img/ground.4880bf4a.png";